import { render } from "./TissuView.vue?vue&type=template&id=20ae7261&scoped=true"
import script from "./TissuView.vue?vue&type=script&lang=js"
export * from "./TissuView.vue?vue&type=script&lang=js"

import "./TissuView.vue?vue&type=style&index=0&id=20ae7261&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ae7261"]])

export default __exports__